(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-actions"] && !Shopify.designMode) return;
  try {
    if (document.documentElement.lang.toLowerCase().startsWith('fr')) {
  const localizedAccounts = new WeakSet();
  const localizeAccountMenus = () => {
    document.querySelectorAll('shopify-account').forEach((account) => {
      const root = account.shadowRoot;
      if (!root || localizedAccounts.has(account)) return;
      const translateLabels = () => {
        root.querySelectorAll('nav[aria-label="Quick links"]').forEach((nav) => {
          nav.setAttribute('aria-label', 'Liens rapides');
        });
      };
      new MutationObserver(translateLabels).observe(root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-label'],
      });
      localizedAccounts.add(account);
      translateLabels();
    });
  };
  customElements.whenDefined('shopify-account').then(localizeAccountMenus);
  document.addEventListener('shopify:section:load', localizeAccountMenus);
}
  } catch(e) { console.error(e); }
})();

})();
